/* eslint-disable arrow-body-style */
import Enum from '../utils/Enum'

export const RECORD_STAGE200 = new Enum({
  chargeOut: {text: '未支付', value: 'ChargeOut'},
  chargeCbCoin: {text: '待发货', value: 'ChargeCbCoin'},
  chargeMailed: {text: '已发货', value: 'ChargeMailed'},
  chargeRefund: {text: '售后中', value: 'ChargeRefund'},
  chargeAppealAgree: {text: '售后完成', value: 'ChargeAppealAgree'},
  chargeAppealDisagree: {text: '售后驳回', value: 'ChargeAppealDisagree'},
})

export const RECORD_STAGE201 = new Enum({
  chargeOut: {text: '未支付', value: 'ChargeOut'},
  chargeCbCoin: {text: '已支付', value: 'ChargeCbCoin'},
})

export const productKind = new Enum({
  lh1: {text: '实体礼物', value: 100},
  lh2: {text: '虚拟礼物', value: 101},
  lh3: {text: '经典打赏', value: 102},
  sd1: {text: '识读商品', value: 103},
})

export const transKind = new Enum({
  lh1: {text: '实体礼物', value: 200},
  lh2: {text: '虚拟礼物', value: 201},
  lh3: {text: '经典打赏', value: 202},
  sd1: {text: '识读商品', value: 203},
})

export const POST_LAYOUT_KIND = new Enum({
  video: {text: '视频', value: 2},
  audio: {text: '音频', value: 4},
})

export const H5_LANGUAGE = new Enum({
  chinese: {
    text: 'zh',
    value: 100,
  },
  english: {
    text: 'en',
    value: 101,
  },
  arabic: {
    text: 'ar',
    value: 102,
  },
  turkish: {
    text: 'tr',
    value: 103,
  },
  indonesian: {
    text: 'id',
    value: 104,
  },
  hindi: {
    text: 'hi',
    value: 105,
  },
  vietnam: {
    text: 'vn',
    value: 106,
  },
})

export const sdCate = {
  ...new Enum({
    ting: {value: 100, text: '听课文'},
    xie: {value: 200, text: '学识字'},
    lihan: {value: 300, text: '名家专访'},
    news: {value: 400, text: '资讯'},

    grade1: {value: 1100, text: '一年级'},
    grade2: {value: 1200, text: '二年级'},
    grade3: {value: 1300, text: '三年级'},
    grade4: {value: 1400, text: '四年级'},
    grade5: {value: 1500, text: '五年级'},
    grade6: {value: 1600, text: '六年级'},

    stage1: {value: 2100, text: '上学期'},
    stage2: {value: 2200, text: '下学期'},

    news1: {value: 3100, text: '教育热点'},

    lihan1: {value: 4100, text: '李罕诵读'},
  }),
  optionsL1() {
    return this.itemList
      .filter(item => {
        return ['ting', 'xie', 'lihan', 'news'].some(key => key === item.alias)
      })
      .map(item => ({value: item.value, label: item.text}))
  },
  optionsGrade() {
    return this.itemList
      .filter(item => {
        return [
          'grade1',
          'grade2',
          'grade3',
          'grade4',
          'grade5',
          'grade6',
        ].some(key => key === item.alias)
      })
      .map(item => ({value: item.value, label: item.text}))
  },
  optionsStage() {
    return this.itemList
      .filter(item => {
        return ['stage1', 'stage2'].some(key => key === item.alias)
      })
      .map(item => ({value: item.value, label: item.text}))
  },
  optionsNews() {
    return this.itemList
      .filter(item => {
        return ['news1'].some(key => key === item.alias)
      })
      .map(item => ({value: item.value, label: item.text}))
  },
  optionsLihan() {
    return this.itemList
      .filter(item => {
        return ['lihan1'].some(key => key === item.alias)
      })
      .map(item => ({value: item.value, label: item.text}))
  },
  optionsTopic() {
    return this.itemList
      .map(itemL1 => {
        switch (itemL1.alias) {
          case 'ting':
            return this.optionsGrade().map(itemL2 => {
              return this.optionsStage().map(itemL3 => ({
                id: [itemL1.value, itemL2.value, itemL3.value].join(','),
                title: [itemL1.text, itemL2.label, itemL3.label].join('>'),
              }))
            })
          case 'xie':
            return this.optionsGrade().map(itemL2 => ({
              id: [itemL1.value, itemL2.value].join(','),
              title: [itemL1.text, itemL2.label].join('>'),
            }))
          case 'lihan':
            return this.optionsLihan().map(itemL2 => ({
              id: [itemL1.value, itemL2.value].join(','),
              title: [itemL1.text, itemL2.label].join('>'),
            }))
          case 'news':
            return this.optionsNews().map(itemL2 => ({
              id: [itemL1.value, itemL2.value].join(','),
              title: [itemL1.text, itemL2.label].join('>'),
            }))
          default:
            return null
        }
      })
      .filter(item => item !== null)
      .flat(Infinity)
  },
  value2TextTopic(value) {
    return value
      .split(',')
      .map(item => this.value2Text(Number(item)))
      .join('>')
  },
  value2LevelTopic(value) {
    const arr = value.split(',')
    return {
      l1: arr.length >= 1 && arr[0],
      l2: arr.length >= 2 && arr[1],
      l3: arr.length >= 3 && arr[2],
    }
  },
  level2ValueTopic(l1, l2, l3) {
    return [l1, l2, l3].filter(item => item !== null).join(',')
  },
  optionsFromL1(l1Value) {
    let optionsL2 = null
    let optionsL3 = null
    switch (this.value2Alias(l1Value)) {
      case 'ting':
        optionsL2 = this.optionsGrade()
        optionsL3 = this.optionsStage()
        break
      case 'xie':
        optionsL2 = this.optionsGrade()
        break
      case 'lihan':
        optionsL2 = this.optionsLihan()
        break
      case 'news':
        optionsL2 = this.optionsNews()
        break
      default:
        break
    }
    return {optionsL2, optionsL3}
  },
}

export const xSkill = {
  ...new Enum({
    ting: {value: 100, text: '话题推荐'},

    grade1: {value: 1001, text: '身边小事'},
    grade8: {value: 1008, text: '在外老乡'},
    grade11: {value: 1011, text: '小城故事'},
    grade13: {value: 1013, text: '从政小学'},
    grade10: {value: 1010, text: '奥星幼儿园'},
    grade12: {value: 1012, text: '小夫子国学馆'},
    grade0: {value: 1000, text: '本地相亲'},
    grade7: {value: 1007, text: '车友专区'},
    grade9: {value: 1009, text: '钓友专区'},
    grade3: {value: 1003, text: '招工启事'},
    grade5: {value: 1006, text: '便民信息'},
    grade2: {value: 1002, text: '商家优惠'},
  }),
  optionsGrade() {
    return this.itemList
      .filter(item => {
        return [
          'grade0',
          'grade1',
          'grade2',
          'grade3',
          'grade5',
          'grade7',
          'grade8',
          'grade9',
          'grade10',
          'grade11',
          'grade12',
          'grade13',
        ].some(key => key === item.alias)
      })
      .map(item => ({value: item.value, label: item.text}))
  },
  optionsFromL1(l1Value) {
    let optionsL2 = null
    const optionsL3 = null
    switch (this.value2Alias(l1Value)) {
      case 'ting':
        optionsL2 = this.optionsGrade()
        break
      default:
        break
    }
    return {optionsL2, optionsL3}
  },
}

const _ = ''

export {_ as default}
